import AsyncSelect, { Option } from "./AsyncSelect";
import { fetchDisabilityCertificateList } from "@/services/disabilityCertificate";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { Module } from "@/constants";
import appConfiguration from "./cfg/AppCfg";

interface DisabilityCertificateSelectProps extends ControllerRenderProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, DisabilityCertificateSelectProps>(
  function DisabilityCertificateSelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <AsyncSelect
        queryKey={[Module.DisabilityCertificates]}
        queryFn={() =>
          fetchDisabilityCertificateList({
            limit: appConfiguration.selectComponentsPaginationLimit,
          })
        }
        enableFilter={false}
        placeholder={t("disabilityCertificateSelect.placeholder")}
        loadingLabel={t("disabilityCertificateSelect.loading")}
        renderName={(item) => `${item.code ?? item.name}`}
        {...props}
        ref={ref}
        className="w-full"
        defaultItem={defaultItem}
      />
    );
  },
);
